<template>
  <div>
    <v-list dense shaped color="transparent">
      <v-list-item-group color="primary">
        <v-list-item
          v-for="(comp, index) in favoriteCompanies"
          :key="index"
          :to="'/cls/company/' + comp.slug"
        >
          <v-list-item-content>
            <v-img
              :src="comp.image"
              v-if="comp.image"
              :max-height="20"
              :max-width="110"
              contain
              position="left center"
              class=""
            ></v-img>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/cls/companies/">
          <v-list-item-content>
            <v-list-item-title class=""> More Companies</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <select-company-dialog
      :show="showCompanySelector"
      @canceled="showCompanySelector = false"
      @companySelected="companySelected($event)"
    ></select-company-dialog>
  </div>
</template>

<script>
import ClCompanyMixin from "@/assets/js/cls/ClCompanyMixin";
export default {
  name: "SelectSoftCompany",
  components: {
    SelectCompanyDialog: () =>
      import("@/components/clStuff/SelectCompanyDialog"),
  },
  mixins: [ClCompanyMixin],
  props: {
    external: {
      type: String,
      default: "MAIN",
    },
  },
  data: function () {
    return {
      showCompanySelector: false,
    };
  },
  computed: {},
  methods: {},
  watch: {},
  mounted: function () {},
};
</script>

<style scoped>
.grayText {
  color: #636363;
}
.v-list-item--dense .v-list-item__icon,
.v-list--dense .v-list-item .v-list-item__icon,
.v-list-item__content {
  padding: 3px 0 !important;
  margin: 0 !important;
}
.v-list-item--dense,
.v-list--dense .v-list-item {
  min-height: 30px;
}
</style>
